module.exports = __webpack_public_path__ + "static/img/co.2d279930.svg";